import React, { useMemo } from "react";
import clsx from "clsx";
import CustomSelect from "../Select/CustomSelect";
import useMainFilter from "../../hooks/useMainFilter";
import useFilteredTransactions from "../../hooks/useFilteredTransactions";
import { MdDateRange, MdWarning } from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import userPreferencesStore from "../../store/userPreferences";
import useAccountLocalStorage from "../../hooks/useAccountLocalStorage";

const ReportsYearSelector: React.FC = () => {
  const { isMainFilterActive } = useMainFilter();
  const { uniqueYears } = useFilteredTransactions();
  const { updateAccountLocalStorage } = useAccountLocalStorage();

  // Usar el estado global de selectedYear desde Zustand
  const { selectedYear, setSelectedYear } = userPreferencesStore(
    (state: any) => ({
      selectedYear: state.selectedYear,
      setSelectedYear: state.setSelectedYear,
    })
  );

  const yearsObject = useMemo(() => {
    const availableYears =
      uniqueYears?.map((year: any) => ({ value: year, label: year })) || [];

    return [
      ...availableYears,
      {
        value: "",
        label: "Todos",
      },
    ];
  }, [uniqueYears]);

  // useEffect(() => {
  // if (!selectedYear || !uniqueYears?.includes(selectedYear)) {
  // if (uniqueYears?.length > 0) {
  // setSelectedYear(uniqueYears[0]);
  // } else {
  // setSelectedYear("");
  //   }
  // }
  // }, [selectedYear, uniqueYears, setSelectedYear]);

  return (
    <div
      className={clsx([
        "flex",
        "w-full",
        "flex-col",
        "md:flex-row",
        "items-center",
        "gap-4",
        "md:gap-4",
      ])}
    >
      <div
        className={clsx([
          "flex",
          "flex-row",
          "gap-2",
          "items-start",
          "w-full",
          "md:w-2/3",
        ])}
      >
        {yearsObject?.length ? (
          <MdDateRange size={ICON_SIZES.MD} className="shrink-0 opacity-100" />
        ) : (
          <MdWarning size={ICON_SIZES.MD} className="shrink-0 opacity-100" />
        )}
        <div className={clsx(["text-sm", "md:text-sm", "opacity-100"])}>
          {isMainFilterActive ? (
            <>
              {yearsObject?.length > 1 ? (
                <>
                  Las transacciones filtradas incluyen más de un año. Puedes
                  seleccionar un año de la lista para filtrar aún más tus
                  resultados.
                </>
              ) : (
                <>
                  {yearsObject?.length ? (
                    <>
                      Las transacciones filtradas incluyen sólo un año. Puedes
                      editar el filtro actual para obtener otros resultados.
                    </>
                  ) : (
                    <>
                      Tu búsqueda no devolvió resultados. Puedes editar el
                      filtro actual para obtener los resultados deseados.
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {yearsObject?.length > 1 ? (
                <>
                  Tienes transacciones realizadas en distintos años. Puedes
                  seleccionar un año de la lista para filtrar tus resultados.
                </>
              ) : (
                <>
                  {yearsObject?.length ? (
                    <>Tus transacciones sólo incluyen un año.</>
                  ) : (
                    <>
                      Aún no tienes transacciones registradas. Puedes registrar
                      una nueva transacción desde el menú principal.
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      <div className={clsx("flex w-full md:w-1/3")}>
        <CustomSelect
          isSearchable={false}
          options={yearsObject}
          disabled={yearsObject?.length <= 1}
          value={selectedYear as string}
          onChange={(e) => {
            updateAccountLocalStorage({ lastYear: e?.value || "" });
            setSelectedYear(e?.value);
          }}
          label="Año"
          placeholder="Todos"
        />
      </div>
    </div>
  );
};

export default React.memo(ReportsYearSelector);
